/**
 * External dependencies
 */
import React from 'react';
import { connect } from 'react-redux';
import page from 'page';

/**
 * Internal dependencies
 */
import Main from 'components/main';
import DocumentHead from 'data/document-head';
import Topbar from 'modules/me/topbar';
import SelectVisualDeckPlan from 'modules/me/select-visual-deck-plan';
import { Stack, Text, Heading, Box } from '@towersystems/towersystems-design-system';
import AnnotatedSection from 'components/annotated-section';
import Notice from 'components/notice';
import { getBusinessName } from 'state/current-user/selectors';
import { getIndustryGroup } from 'state/current-user/selectors';
import { getCurrentRental } from 'state/current-rental/selectors';

/**
 * Style dependencies
 */
import './styles.scss';


const NewPlan = ({ businessName, industryGroup, currentRental }) => {
    currentRental = currentRental.filter(rental => rental.subscription.status == 'active');
    currentRental = currentRental.filter(rental => rental.subscription.plan_id.toLowerCase().includes('retailer-rental'));

    const allowed = currentRental.some(rental => (rental.subscription.plan_id.includes('retailer-rental-advanced')
        || rental.subscription.plan_id.includes('retailer-rental-Advanced')
        || rental.subscription.plan_id.includes('retailer-rental-ultimate')
        || rental.subscription.plan_id.includes('retailer-rental-Ultimate')));

    if(industryGroup.toLowerCase() == "newsxpress" ||  allowed == true) {
        //
    } else {
        page.redirect('/dashboard');
    }
    
    const onSuccessPlanSelect = () => {
        page.redirect('/dashboard/visual-deck');
    };

    return (
        <Box>
            <DocumentHead title='Billing - Tower Systems' />
            <Topbar title='Visual Deck' subTitle={'Hello ' + businessName} selected='visual-deck' />
            <Box marginBottom='xxlarge'>
                <Text className="plan__content">
                Visual Deck is a powerful analytics platform that gives you a 
                comprehensive view of your business performance. Access key metrics like gross profit, 
                revenue trends, and top-selling products, all in one place. To keep you informed, 
                Visual Deck also sends you weekly or monthly emails with summarised insights, 
                so you can stay on top of your business effortlessly.
                </Text>
            </Box>
            <Main padding='xxlarge'>
                <Stack space='xxlarge'>
                    <Box>
                        <Heading level='3'>Select a Visual Deck plan</Heading>
                        <Text>
                            *Prices are excluding any applicable discounts. Please click on a plan below to subscribe.
                        </Text>
                    </Box>
                    <Box>
                        <SelectVisualDeckPlan afterSuccess={onSuccessPlanSelect} />
                    </Box>
                </Stack>
            </Main>
        </Box>
    );
};

export default connect((state) => ({businessName: getBusinessName(state),industryGroup: getIndustryGroup(state),currentRental: getCurrentRental(state),}), {})(NewPlan);
